import React, { useEffect, useState } from 'react'
import SliderCarouselAdmin from '../components/SliderCarouselAdmin'
import Footer from '../components/footer'
import { createGlobalStyle } from 'styled-components'
import Reveal from 'react-awesome-reveal'
import { keyframes } from '@emotion/react'
import { isUserAdmin, requestReleaseAllToken, pauseToken, unpauseToken, renounceTokenOwnership } from '../data'

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.sticky.white {
    background: #212428;
    border-bottom: 0;
    box-shadow: 0 4px 20px 0 rgba(10,10,10, .8);
  }
  header#myHeader.navbar .search #quick_search{
    color: #fff;
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader.navbar.white .btn, .navbar.white a, .navbar.sticky.white a{
    color: #fff;
  }
  header#myHeader .dropdown-toggle::after{
    color: #fff;
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: none !important;
  }
  header#myHeader .logo .d-3{
    display: block !important;
  }
  .jumbotron.no-bg{
    background: center bottom;
    background-size: cover;
    height: 100vh;
  }
  footer.footer-light .subfooter span img.d-1{
    display: none !important;
  }
  footer.footer-light .subfooter span img.d-3{
    display: inline-block !important;
  }
  .de_countdown{
    right: 10px;
    color: #fff;
  }
  .author_list_pp{
    margin-left:0;
  }
  footer.footer-light .subfooter{
    border-top: 1px solid rgba(255,255,255,.1);
  }
`

const AdminHome = () => {

const [isAdm, setIsAdm] = useState(false)

// const intrusiveResponse = () => {
//   alert("Sorry We can't show you this page. \nTaking you back home on Ok!")
//   window.open("/","_self")
// }

  useEffect(() => {
    const isAdmin = async () => {
      const response = await isUserAdmin() 
      if(response){
        setIsAdm(response)
        return response
      }else{
        setIsAdm(response)
        return response
      }
      
      
    }
    isAdmin();
  },[isAdm])
  return(
  <div>
    <GlobalStyles />
    <section
      className="jumbotron no-bg"
      style={{ backgroundImage: `url(${'./img/background/7.jpg'})` }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="spacer-single"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={0}
              duration={600}
              triggerOnce
            >
              <h6 className="">
                <span className="text-uppercase color">AFER Token Seed Sale.</span>
              </h6>
            </Reveal>
            <div className="spacer-10"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={300}
              duration={600}
              triggerOnce
            >
              <h1 className="">AFER</h1>
            </Reveal>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={600}
              duration={600}
              triggerOnce
            >
              <p className=" lead">
              You can manually release tokens to all buyers at the right time.<br/>
              Note: You need to switch to your admin address in your wallet.
              </p>
            </Reveal>
            <div className="spacer-10"></div>
            <Reveal
              className="onStep"
              keyframes={fadeInUp}
              delay={800}
              duration={900}
              triggerOnce
            >
              <span
                onClick={ async() => await requestReleaseAllToken()}
                className="btn-main lead"
              >
                Release All Due Tokens
              </span>
              <br/>
              <span
                onClick={async () => await pauseToken()}
                className="btn-main lead"
              >
                Pause Token
              </span>
              <br/>
              <span
                onClick={async () => await unpauseToken()}
                className="btn-main lead"
              >
                Unpause Token
              </span>
              <br/>
              <span
                onClick={async () => await renounceTokenOwnership()}
                className="btn-main lead"
              >
                Renounce Ownership
              </span>
              <div className="mb-sm-30"></div>
            </Reveal>
            <div className="spacer-double"></div>
          </div>
          <div className="col-lg-6 px-0">
            <h5 className="">
                <b className="text-uppercase color">Use the slider to do more!</b>
            </h5>
            <SliderCarouselAdmin />
          </div>
        </div>
      </div>
    </section>

    <div className="clearfix"></div>  
    <div className="spacer-single"></div>

    <div className="col-lg-12">
      <Footer/>
  </div>
    
  </div>
  )
}
export default AdminHome
